import * as angular from 'angular';
import * as _ from 'lodash';

import {States} from "../../shared/config/constant.module";
import {apsEnums} from "../../shared/dto/aps.enums";
import AddDefectCauseName, {openAddDefectCause} from "./addDefectCause.controller";
import AddDefectTypeName, {openAddDefectType} from "./addDefectType.controller";
import NotifyServiceName, {NotifyService} from "../../services/notify/notify.service";
import LoaderServiceName, {LoaderService} from "../../components/loader/loader.service";
import DefectTypeServiceName, {DefectTypeService} from "../../services/defects/defectType.service";
import template from './defectTypes.tpl.html';
import EditDefectTypeName, {openEditDefectType} from "./editDefectType.controller";
import EditDefectCauseName, {openEditDefectCause} from "./editDefectCause.controller";

let requires = [AddDefectCauseName, AddDefectTypeName, EditDefectTypeName, NotifyServiceName, LoaderServiceName,
  DefectTypeServiceName, EditDefectCauseName];

interface DefectTypesController {
  severityName(severity: apsEnums.Severity): string;
  defectTypes: any;
  editDefectType(defectTypeId: string): any;
  addDefectType(): any;
  sortBy: string;
}

export default angular.module('aps.controller.defectTypes', requires)
  .config(function($stateProvider: angular.ui.IStateProvider) {
    $stateProvider.state({
      name: States.DEFECT_TYPES,
      url: '/admin/defectTypes',
      controller: 'DefectTypesCtrl as defectTypesCtrl',
      template: template,
      data: {
        pageTitle: 'Defect Types',
        authorizeAdmin: true
      }
    });
  })
  .controller('DefectTypesCtrl', defectTypesCtrl)
  .name;

function defectTypesCtrl(
  $modal: mm.foundation.modal,
  notifyService: NotifyService,
  loaderService: LoaderService,
  defectTypeService: DefectTypeService): DefectTypesController {
  'use strict';
  var vm = this as DefectTypesController;
  vm.sortBy = 'name';
  

  var updateDefectType = function(defectTypeDetails) {
    if ((defectTypeDetails || '') !== '') {
      var defectTypeUpdated = _.find(vm.defectTypes,
        function (item: any) {
          return item.id === defectTypeDetails.id;
        });
      if ((defectTypeUpdated || '') !== '') {
        defectTypeUpdated.legacyId = defectTypeDetails.legacyId;
        defectTypeUpdated.name = defectTypeDetails.name;
        defectTypeUpdated.description = defectTypeDetails.description;
        defectTypeUpdated.courseOfActionName = defectTypeDetails.courseOfActionName;
        defectTypeUpdated.priority = defectTypeDetails.priority;
        defectTypeUpdated.enabled = defectTypeDetails.enabled;
        defectTypeUpdated.defaultInspectionSampleSize = defectTypeDetails.defaultInspectionSampleSize;
        defectTypeUpdated.probability = defectTypeDetails.probability;
      }
    }
  };

  let addDefectCauseModal = function(defectTypeId){
    let result = openAddDefectCause({
      defectTypeId: defectTypeId
    }, $modal);

    result.then(function (data) {
      if (data) {
        vm.editDefectType(defectTypeId);
      }
    });
  };

  var editDefectCauseModal = function(modalData){
    var result = openEditDefectCause({
      defectCause: modalData.defectCause
    }, $modal);

    result.then(function () {
      vm.editDefectType(modalData.defectTypeId);
    });
  };

  vm.addDefectType = function() {
    var result = openAddDefectType($modal);

    result.then(function (data) {
      if ((data || '') !== '') {
        var item = {
          id: data.id,
          legacyId: data.legacyId,
          name: data.name,
          defaultInspectionSampleSize : data.defaultInspectionSampleSize,
          description: data.description
        };
        vm.defectTypes.push(item);
      }
    });
  };

  vm.editDefectType = function(defectTypeId: string){
    let result = openEditDefectType({
      defectTypeId: defectTypeId
    }, $modal);

    result.then(function (data) {
      if ((data || '') !== '') {
        if ((data.action || '') !== '') {
          switch (data.action) {
            case 'editCause':
              editDefectCauseModal(data);
              break;
            case 'addCause':
              addDefectCauseModal(data.defectTypeId);
              break;
            case 'return':
              updateDefectType(data.defectTypeDetails);
              break;
            default :
              break;
          }
        }
      }
    });
  };

  vm.severityName = function(severity: apsEnums.Severity) {
    return apsEnums.Severity[severity];
  };

  var promise = defectTypeService.getDefectTypesAndClassifications()
    .then(function (defectTypesAndClassifications) {
    vm.defectTypes = defectTypesAndClassifications.types;
    }, notifyService.handleApiErrors);
  loaderService.loadingPromise(promise);

  return vm;
}



// WEBPACK FOOTER //
// ./src/app/controllers/defectTypeAdmin/defectTypes.controller.ts